import axios from "axios";
import store from "../store";
import { logout } from "../store/slices/authSlice";

const apiV3 = axios.create({
  baseURL: process.env.REACT_APP_API_V3_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
apiV3.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiV3.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

export { apiV3 };
